export const ACCOUNT_PERMISSIONS = Object.freeze({
  ADMIN: 'admin',
  CAMPAIGNS: 'campaigns',
  CALL_LOGS: 'call_logs',
  BILLING: 'billing'
})

export const ALL_ACCOUNT_PERMISSIONS = Object.freeze(['admin', 'campaigns', 'call_logs', 'billing'])
export const ACCOUNT_PERMISSION_OPTIONS = Object.freeze([
  { value: 'admin', text: 'Account admin' },
  { value: 'campaigns', text: 'Campaigns' },
  { value: 'call_logs', text: 'Call logs' },
  { value: 'billing', text: 'Billing' }
])
// A seller works with offers, a buyer with campaigns, so the same permission reads differently.
export function accountPermissionOptions(isSellerAccount) {
  return ACCOUNT_PERMISSION_OPTIONS.map(option =>
    isSellerAccount && option.value === 'campaigns' ? { ...option, text: 'Offers' } : option)
}

export const ACCOUNT_ROLES = Object.freeze({ ADMIN: 'admin', USER: 'user' })

const lowerKeys = list => Array.isArray(list)
  ? [...new Set(list.filter(key => typeof key === 'string').map(key => key.toLowerCase()))]
  : []

export function effectivePermissions(member = {}) {
  if (!Array.isArray(member.permissions)) {
    // Unversioned auth memberships predate the projection; a versioned record with no list has no grants.
    return member.permissionsVersion == null ? [...ALL_ACCOUNT_PERMISSIONS] : []
  }
  return effectiveMemberPermissions(member)
}

export function effectiveMemberPermissions(member = {}) {
  const effective = lowerKeys(member.permissions).filter(key => Object.values(ACCOUNT_PERMISSIONS).includes(key))
  if (effective.includes('admin') && !effective.includes('billing')) effective.push('billing')
  return effective
}

// An array means any one of its permissions is enough.
export function hasAccountPermission(granted, permission) {
  return Array.isArray(permission) ? permission.some(key => granted.includes(key)) : granted.includes(permission)
}

export function canonicalPermissions(selection) {
  const keys = lowerKeys(selection)
  const result = ALL_ACCOUNT_PERMISSIONS.filter(key => keys.includes(key))
  if (result.includes('admin') && !result.includes('billing')) result.push('billing')
  return result
}

export function requirePermissionSelection(selection) {
  const result = canonicalPermissions(selection)
  if (!result.length) throw new Error('Select at least one account permission.')
  return result
}

export function firstAllowedRoute(hasPermission, isBuyer) {
  if (hasPermission('campaigns')) return isBuyer ? 'ListBuyerCampaigns' : 'SellerAvailableOffers'
  if (hasPermission('call_logs')) return isBuyer ? 'BuyerCallLogs' : 'SellerCallLogs'
  if (hasPermission('billing')) return 'MyAccount'
  if (hasPermission('admin')) return 'UserManagement'
  return 'NoAccountAccess'
}
